import axiosApiInstance from "../../../app/axios";
import { getJwtToken } from "../../../app/common";
import { PARKIT_API_BASE_URL } from "../../../app/utils";

const url = `${PARKIT_API_BASE_URL}/parkit/v2/faq-groups`;
const auth = () => ({
  headers: { Authorization: `Bearer ${getJwtToken()}` },
});

export const getFaq = () => axiosApiInstance.get(`${PARKIT_API_BASE_URL}/parkit/v2/public/faq`);

export const createFaqGroup = (group) => axiosApiInstance.post(url, group, auth());

export const updateFaqGroup = (group) => axiosApiInstance.put(`${url}/${group.id}`, group, auth());

export const deleteFaqGroup = (id) => axiosApiInstance.delete(`${url}/${id}`, auth());

export const uploadFaqImage = (file) => {
  const data = new FormData();
  data.append("file", file);
  return axiosApiInstance.post(`${url}/images`, data, auth());
};
